module.exports = __webpack_public_path__ + "static/media/refresh.1efad2bb.svg";